import { DELETE, VIEW, EDIT } from '@/helpers/enums/table-actions'


export const TABLE_ACTIONS = Object.freeze([
  VIEW,
  EDIT,
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Название',
    value: 'display_name',
    sortable: false,
  },
])
